<section class="ppw f fc oy tea fa">
    <h3>{title}</h3>
    <slot />
</section>

<script>
    export let title = 'page title';
</script>
